 import navigation from './core/navigation';
 import observe from './core/observer';
 import stickyHeader from './site/stickyHeader';
 import marquee from './site/marquee';
 import slickSlider from './site/slickSlide';
 import featherlight from './site/featherlight';

$ ( function() {
  navigation.init();
  observe();
  stickyHeader.init();
  marquee.init();
  slickSlider.init();
  featherlight.init();
});